'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-08
 */

import Cookies from 'js.cookie'
import _ from 'lodash'

export function security () {
	return {
		getSharedLoginStatus: function () {
			// Get domain shared status cookie
			return Promise.resolve(Cookies.get('e24AppLoginStatus')).then((loginStored) => {
				if (_.isNil(loginStored)) {
					return {status: false, role: null, token: null}
				} else {
					if (!_.isNil(loginStored.token)) {
						// Set token in local storage to fast access
						localStorage.setItem('token', loginStored.token)
					} else {
						localStorage.removeItem('token')
					}
					return loginStored
				}
			})
		},
		getSharedAuthHeader: function () {
			return 'Bearer ' + localStorage.getItem('token')
		}
	}
}



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/security-service.js